module.exports = __webpack_public_path__ + "static/media/Internet Addiction.0886613d.svg";